module.exports = __webpack_public_path__ + "img/Nepal.df5ae1a1.svg";